<ng-container *ngIf="data.type === dialogType.NORMAL">
    <mat-icon class='dialog-icon' [style.color]="data.color">{{ data.icon }} </mat-icon>
    <mat-icon *ngIf="data.showClose !== false" class='dialog-close' (click)="dialogRef.close(false)"> close </mat-icon>

    <div class="dialog-row">
        <h1 class='dialog-title' md-dialog-title> {{ data.title }} </h1>
        <p class='dialog-message' md-dialog-content>{{ data.text }} <a *ngIf="data.link" [href]="data.link"> {{ 'translations.link' | translate }} </a></p>

    </div>

    <div class='dialog-button-container' md-dialog-actions>
        <button *ngIf="data.showCancel !== false" class='dialog-button cancel' md-button (click)="dialogRef.close(false)">
            {{ data.cancelText }}
        </button>

        <button *ngIf="data.showAction !== false" class='dialog-button confirm' [style.background-color]="data.color" md-button (click)="dialogRef.close(true)">
            {{ data.actionText }}
        </button>
      </div>
</ng-container>

<ng-container *ngIf="data.type === dialogType.INPUT">
    <mat-icon class='dialog-icon'>{{ data.icon }} </mat-icon>
    <mat-icon *ngIf="data.showClose !== false" class='dialog-close' (click)="dialogRef.close({ success: false, data: data })"> close </mat-icon>

    <div class="dialog-row">
        <h1 class='dialog-title' md-dialog-title> {{ data.title }} </h1>
        <p class='dialog-message input-message' md-dialog-content>{{ data.text }} </p>
    </div>

    <div class="input-row">
        <ng-container *ngFor="let input of data.inputs">
            <input *ngIf="input.type !== 'number'" [(ngModel)]="input.value" class="input" [type]="input.type" [placeholder]="input.placeholder" [value]="input.value" />
            <app-numeric-attribute *ngIf="input.type === 'number'" [showConfirmButton]="false" [showLabel]="false" [attribute]="input.numericChange" [currentValue]="stringToNumber(input.value)" (valueChanged)="input.value = $event.toString()"></app-numeric-attribute>
        </ng-container>
    </div>

    <div class='dialog-button-container' md-dialog-actions>
        <button *ngIf="data.showCancel !== false" class='dialog-button cancel' md-button (click)="dialogRef.close({ success: false, data: data })">
            {{ data.cancelText }}
        </button>

        <button *ngIf="data.showAction !== false" class='dialog-button confirm' md-button (click)="dialogRef.close({ success: true, data: data })">
            {{ data.actionText }}
        </button>
      </div>
</ng-container>
